import * as React from "react";

import type { MenuListProps } from "@fluentui/react-components";
import {
  useMenuList_unstable,
  useMenuListStyles_unstable,
  renderMenuList_unstable,
  useMenuListContextValues_unstable,
} from "@fluentui/react-components";

export const AppMenuList = React.forwardRef<HTMLDivElement, MenuListProps>(
  (props, ref) => {
    // map to the needed state here. TO-DO
    const state = useMenuList_unstable(props, ref);
    const contextValues = useMenuListContextValues_unstable(state);
    useMenuListStyles_unstable(state);
    return renderMenuList_unstable(state, contextValues);
  }
);
